<template>
  <div class="addressInfo">
    <div class="box">
      <div class="abount_item" v-for="(item,index) in addressInfo" :key="index" v-show="addressInfo">
        <div class="item" @click="goLog(item)">
          <p class="title">商品邮寄信息</p>
          <!-- <div class="item_list">
                         <span>姓名：</span>
                         <span>{{item.deliveryContact}}</span>
          </div>-->
          <!-- <p class="title">{{item.deliveryObject|filt}}地址</p> -->
          <div class="item_list">
            <span>收货方</span>
            <span>{{item.deliveryObject|filt}}</span>
          </div>
          <div class="item_list">
            <span>快递公司</span>
            <span>{{item.expressCompany}}</span>
          </div>
          <div class="item_list">
            <span>快递单号</span>
            <span style="color:#36B374;">{{item.expressNo}}</span>
          </div>
          <!-- <div class="item_list">
                         <span>联系方式：</span>
                         <span>{{item.deliveryContactTel}}</span>
                    </div>
                    <div class="item_list">
                         <span>地址：</span>
                         <span>{{item.deliveryAddress}}</span>
          </div>-->

          <div class="item_list">
            <span>是否收货</span>
            <span v-if="item.deliveryStatus">是</span>
            <span v-if="!item.deliveryStatus">否</span>
          </div>
        </div>
      </div>
      <div
        class="abount_item"
        v-if="this.$store.state.detailInfo.visitorAddress||this.$store.state.detailInfo.visitorContactTel"
      >
        <div class="item">
          <p class="title">游客地址</p>
          <div class="item_list">
            <span>联系人</span>
            <span>{{this.$store.state.detailInfo.visitorContact}}</span>
          </div>
          <div class="item_list">
            <span>联系方式</span>
            <span>{{this.$store.state.detailInfo.visitorContactTel}}</span>
          </div>
          <div class="item_list">
            <span>地址</span>
            <span>{{this.$store.state.detailInfo.visitorAddress}}</span>
          </div>
        </div>
        <!-- <div class="space"></div> -->
      </div>
      <div class="abount_item">
        <div
          class="item"
          v-if="this.$store.state.detailInfo.deliveryRefundAddress||this.$store.state.detailInfo.deliveryContactTel"
        >
          <p class="title" v-if="this.$store.state.detailInfo.deliveryObject==10">监理中心地址</p>
          <p class="title" v-if="this.$store.state.detailInfo.deliveryObject==30">企业地址</p>
          <div class="item_list">
            <span>姓名</span>
            <span>{{this.$store.state.detailInfo.deliveryContact}}</span>
          </div>
          <div class="item_list">
            <span>联系方式</span>
            <span>{{this.$store.state.detailInfo.deliveryContactTel}}</span>
          </div>
          <div class="item_list">
            <span class="adress_info">地址</span>
            <span class="adress_text">{{this.$store.state.detailInfo.deliveryRefundAddress}}</span>
          </div>
        </div>
        <!-- <div class="space"></div> -->
      </div>

      <div
        class="box1"
        v-if="addressInfo==''&&!this.$store.state.detailInfo.deliveryRefundAddress&&!this.$store.state.detailInfo.visitorAddress"
      >
        <img src="../../../../assets/empty/ic_wuxingxi.png" alt="">
        <p class="tip1">暂无数据</p>
      </div>
      <!-- <div class="item">
               <p class="title">游客地址</p>
               <div class="item_list">
                    <span>姓名：</span>
                    <span>张三</span>
               </div>
               <div class="item_list">
                    <span>联系方式：</span>
                    <span>17638374928</span>
               </div>
               <div class="item_list">
                    <span>地址：</span>
                    <span>云南省-昆明市-五华区 环城南路777号</span>
               </div>
               <div class="item_list">
                    <span>快递公司：</span>
                    <span>圆通快递</span>
               </div>
               <div class="item_list">
                    <span>快递单号：</span>
                    <span>YT36273817628271</span>
               </div>
               <div class="item_list">
                    <span>是否收货：</span>
                    <span>否</span>
               </div>
      </div>-->
    </div>
  </div>
</template>
<script>
    import util from '../../../../utils/common';
    export default {
        props: ['addressInfo'],
        data () {
            return {
                // configlist: this.$store.state.configlist.DELIVERY_OBJECT
            };
        },
        created () {},
        methods: {
            goLog (item) {
                //     console.log(item.expressNo);
                let phone = item.deliveryContactTel.substring(7, 11); this.$router.push(
                    'Logistics?orderNum=' +
                        item.expressNo +
                        '&orderMessage=' +
                        item.expressCompany +
                        '&expressCompanyCode=' +
                        item.expressCompanyCode +
                        '&phone=' +
                        phone +
                        '&expressId=' +
                        item.expressId
                );
            }
        },
        filters: {
            filt (value) {
                let text;
                util.getJsonLocal('configList').DELIVERY_OBJECT.map((item, index) => {
                    if (value === item.code) {
                        text = item.name;
                    }
                });
                return text;
            }
        }
    };
</script>
<style scoped lang="less">
.addressInfo {
  // margin-top: 184px;
  width:100%;
  padding: 170px 14px 78px 14px;
  background-color: #fafafa;
  box-sizing: border-box;
  .box {
    width: 100%;
    .abount_item {
      margin-top: 20px;
      .item {
        background-color: #ffffff;
        padding: 16px;
        box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        .title {
          font-size: 14px;
          color: #333;
          font-weight: 700;
        }
        .item_list {
          margin-top: 15px;
          position: relative;

          span {
            font-size: 14px;
            color: #4a4a4a;
          }
          span:nth-child(1) {
            width: 23%;
            display: inline-block;
            vertical-align: middle;
            color: #999;
          }
          span:nth-child(2) {
            width: 74%;
            display: inline-block;
            vertical-align: middle;
            line-height: 1.4em;
          }
          .search {
            position: absolute;
            right: 86px;
            top: 0;
            width: 20px;
            height: 20px;
          }
          .adress_info{
            display: inline-block;
            vertical-align: top!important;
            line-height: 1.3em;
          }
          .adress_text{
            display: inline-block;
            vertical-align: top!important;
            line-height: 1.3em;
          }
        }
      }
      .space {
        width: 100%;
        height: 4px;
        background-color: #eeeeee;
      }
    }
    .box1 {
      text-align: center;
      padding-top: 150px;
      background: #fbfbfb;
      height: 483px;
      img {
        display: inline-block;
        width: 74px;
        height: 62px;
      }
      .tip1 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 24px;
      }
      .tip2 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 8px;
      }
    }
  }
}
</style>
